import React, { useState } from 'react';
import { withRouter } from '../../common/withRouter';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Notification,
  ButtonOBSOLETED,
  Loader,
  Message
} from '../../web.common';
import { Divider, DetailsRightBar, NoLink, Link } from './DetailsRightBar';
import withApi from '../higherOrderComponents/withApi';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import AsyncSelect from "react-select/async";

const FacilityInternal = ({
  api,
  history
}) => {

  const initialValue = {
    Name: '',
    Summary: '',
    ContactName: '',
    ContactNumber: '',
    ContactEmail: '',
    Type: 'Undefined',
    Provider: null,
    Area: null,
    Category: 'None',
    PlaceAddress: '',
    PlaceAddressText: '',
    PlaceLatitude: '',
    PlaceLongitude: '',
    PlaceEmailAddressInner: '',
    PlaceLogoUrl: '7c2f125f-b311-4ac1-b698-1ef6b753455b-squared',
    PlaceMapsUrl: '',
    PlaceName: '',
    PlacePhoneNumber: '',
    PlacePhotoUrl: '1ee9d569-4a6d-4e2e-b325-300b946f9923-list',
    PlacePhotoListUrl: '1ee9d569-4a6d-4e2e-b325-300b946f9923-list',
    PlacePhotoListPreviewUrl: '62def2d9-faa8-407e-ac20-30a06fba817a-list-preview',
    PlacePhotoSquareUrl: '7c2f125f-b311-4ac1-b698-1ef6b753455b-squared',
    PlacePhotoSquarePreviewUrl: '40795af1-8f6f-4d65-842d-e6329b24d5f8-squared-preview',
    PlacePhotoHugeUrl: 'ab7687a7-6ad0-48a9-a2c0-6c68850a5691-huge',
    PlacePhotoHugePreviewUrl: 'bbf96340-d71f-488b-86be-ff2394c901b2-huge-preview',
    PlaceRating: '',
    PlaceWebsiteUrl: '',
    PlaceId: '',
    Slug: '',
    PlaceOpeningHours: [],
    PicturePreview: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAYAAABbNsX4AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAASUlEQVR4nGORMA36rywnxXD19kMGfj5uBmEBPgYWBWkJBlUFGYYQTzuGF6/fMRw9e5WB5ezV2wz/GRgY9h0/z8DLw8XAwszEAAAl8BGj0uhjlQAAAABJRU5ErkJggg=='
  }

  const [isEditing, doEdit] = useState(initialValue);
  const [editedNotification, setNotification] = useState(null);

  const formLabelStyle = {
    display: "table-cell",
    width: "20%",
    whiteSpace: "nowrap",
    fontWeight: "bold",
    verticalAlign: "top"
  };

  const formSpanStyle = {
    display: "table-cell",
  };

  const rowStyle = {
    display: "table",
    width: "100%",
    margin: "auto",
    marginBottom: "0"
  };

  const containerStyle = {
    width: '80%',
    margin: 'auto',
    backgroundColor: 'white',
    border: "1px solid #e5e5e5",
    padding: "1.2rem"
  };

  const textAreaStyle = {
    width: '100%'
  };

  const addFacility = async (event, receivedProps) => {
    const validationResponse = validateForm(receivedProps);

    if (validationResponse.success == false) {
      event.preventDefault();
      setNotification(new Message(validationResponse.type, validationResponse.message));
      return;
    }
    const { Id: facilityId } = await api.facilities.saveNewFacilityData(receivedProps);
    setNotification(new Message('success', 'Facility created successfully.'));

    await history.push(`/facility/${facilityId}`);
  }

  const lookupProvider = (value) => {
    const result = api.providers.lookupByNameOrId(value);
    return result;
  }

  const lookupArea = async (value) => {
    const result = await api.areas.lookupByNameOrId(value);
    return result;
  }

  const validateForm = (propsToValidate) => {

    const emptyFields = [];
    let response = {
      success: false,
      type: 'error',
      message: ''
    };

    if (propsToValidate.Name.trim() == '') {
      emptyFields.push('Name');
    }
    if (propsToValidate.PlaceAddressText.trim() == '') {
      emptyFields.push('Address');
    }
    if (propsToValidate.PlaceLongitude == '' || !propsToValidate.PlaceLongitude) {
      emptyFields.push('Longitude');
    }
    if (propsToValidate.PlaceLatitude == '' || !propsToValidate.PlaceLatitude) {
      emptyFields.push('Latitude');
    }
    if (propsToValidate.Area == null) {
      emptyFields.push('Area');
    }
    if (propsToValidate.Provider == null) {
      emptyFields.push('Provider');
    }

    if (emptyFields.length == 1) {
      response.message = `Unable to save. The ${emptyFields} field is mandatory.`
    } else if (emptyFields.length > 1) {
      response.message = `Unable to save. ${emptyFields.join(', ')} are mandatory.`
    } else {
      response.success = true;
      response.type = 'success';
    }

    return response;
  }

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          <Notification newMessage={editedNotification} />
          <PageTop
            documentTitle={`Facility`}
            documentDescription={`Facility`}
          />
          {
            isEditing ?
              (<React.Fragment>
                <h2 className='main-page-header main-page-header-with-subheader'>
                  Facility
                </h2>
                <h5 className='main-page-subheader'><i>New facility</i></h5>
                <br />
                <div style={containerStyle}>
                  <div style={rowStyle}>
                    <label for="name" style={formLabelStyle}>{"Name*"}</label>
                    <span style={formSpanStyle} >
                      <input name="name" id="name"
                        placeholder='Name'
                        value={isEditing.Name}
                        onChange={({ target }) => doEdit({ ...isEditing, Name: console.log(target.value) || target.value })} />
                    </span>
                  </div>
                  <hr />
                  <div style={rowStyle}>
                    <label for="address" style={formLabelStyle}>{'Address*'}</label>
                    <span style={formSpanStyle} >
                      <input name="address" id="address"
                        placeholder='Address'
                        value={isEditing.PlaceAddressText}
                        onChange={({ target }) =>
                          doEdit(
                            { ...isEditing, PlaceAddressText: console.log(target.value) || target.value })
                        }
                      />
                    </span>
                  </div>
                  <br />
                  <div style={rowStyle}>
                    <label for="latitude" style={formLabelStyle}></label>
                    <span style={formSpanStyle} >
                      <input name="latitude" id="latitude"
                        placeholder='Place Latitude'
                        value={isEditing.PlaceLatitude}
                        onChange={({ target }) =>
                          doEdit({ ...isEditing, PlaceLatitude: console.log(target.value) || target.value })
                        }
                      />
                    </span>
                  </div>
                  <br />
                  <div style={rowStyle}>
                    <label for="longitude" style={formLabelStyle}></label>
                    <span style={formSpanStyle} >
                      <input name="longitude" id="longitude"
                        value={isEditing.PlaceLongitude}
                        placeholder='Place Longitude'
                        onChange={({ target }) =>
                          doEdit({ ...isEditing, PlaceLongitude: console.log(target.value) || target.value })
                        } />
                    </span>
                  </div>
                  <hr />
                  <div style={rowStyle}>
                    <label for="email" style={formLabelStyle}>Email</label>
                    <span style={formSpanStyle} >
                      <input style={textAreaStyle} name="email" id="email"
                        placeholder='Email'
                        value={isEditing.PlaceEmailAddressInner}
                        onChange={({ target }) =>
                          doEdit({ ...isEditing, PlaceEmailAddressInner: console.log(target.value) || target.value })
                        }
                      />
                    </span>
                  </div>
                  <hr />
                  <div style={rowStyle}>
                    <label for="provider" style={formLabelStyle}>
                      {'Provider*'}
                    </label>
                    <span style={formSpanStyle}>
                      <AsyncSelect
                        className="react-select-filters-section"
                        classNamePrefix="react-select-filters-section-prefix"
                        defaultOptions
                        placeholder='Select Provider...'
                        value={isEditing.Provider}
                        cacheOptions
                        onChange={(selection) =>
                          doEdit({
                            ...isEditing,
                            Provider: console.log(selection) || selection,
                          })
                        }
                        loadOptions={async (inputValue) => lookupProvider(inputValue)}
                      ></AsyncSelect>
                    </span>
                  </div>
                  <hr />
                  <div style={rowStyle}>
                    <label for="area" style={formLabelStyle}>
                      {'Area*'}
                    </label>
                    <span style={formSpanStyle}>
                      <AsyncSelect
                        className="react-select-filters-section"
                        classNamePrefix="react-select-filters-section-prefix"
                        defaultOptions
                        placeholder='Select Area...'
                        value={isEditing.Area}
                        cacheOptions
                        onChange={(selection) =>
                          doEdit({
                            ...isEditing,
                            Area: console.log(selection) || selection,
                          })
                        }
                        loadOptions={async (inputValue) => lookupArea(inputValue)}
                      ></AsyncSelect>
                    </span>
                  </div>
                  <hr />
                  <div style={rowStyle}>
                    <label for="website" style={formLabelStyle}>Website Url</label>
                    <span style={formSpanStyle} >
                      <input style={textAreaStyle} name="website" id="website"
                        placeholder='Website Url'
                        value={isEditing.PlaceWebsiteUrl}
                        onChange={({ target }) => doEdit({ ...isEditing, PlaceWebsiteUrl: console.log(target.value) || target.value })}
                      />
                    </span>
                  </div>
                  <hr />
                  <div style={rowStyle}>
                    <label for="phoneNumber" style={formLabelStyle}>Phone Number</label>
                    <span style={formSpanStyle} >
                      <input style={textAreaStyle} name="phoneNumber" id="phoneNumber"
                        placeholder='Phone Number'
                        value={isEditing.PlacePhoneNumber}
                        onChange={({ target }) =>
                          doEdit(
                            {
                              ...isEditing,
                              PlacePhoneNumber: console.log(target.value) || target.value

                            })
                        }
                      />
                    </span>
                  </div>
                  <hr />
                  <div style={rowStyle}>
                    <label for="slug" style={formLabelStyle}>Slug</label>
                    <span style={formSpanStyle} >
                      <input style={textAreaStyle} name="slug" id="slug"
                        placeholder='Slug'
                        value={isEditing.Slug}
                        onChange={({ target }) => doEdit({ ...isEditing, Slug: console.log(target.value) || target.value })}
                      />
                    </span>
                  </div>
                  <br />
                  <br />
                  <div style={{ justifyContent: 'center', display: 'flex', gap: '1.5rem' }}>
                    <ButtonOBSOLETED
                      type="submit"
                      buttonContent="Save"
                      onClick={async (e) => {
                        await addFacility(e, isEditing);
                      }} />
                  </div>
                </div>
                <DetailsRightBar>
                  <Divider>Links</Divider>
                  <NoLink>None</NoLink>
                  <Divider>Actions</Divider>
                  <NoLink>None</NoLink>
                </DetailsRightBar>
              </React.Fragment>) :
              <>
                <br />
                <br />
                <Loader />
              </>
          }

        </React.Fragment>)
      }
    </LayoutContext.Consumer>);
}

const FacilityAdd = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(FacilityInternal)
));

FacilityAdd.requiresLogin = true;
FacilityAdd.propTypes = { isLoggedIn: PropTypes.bool };

export default FacilityAdd;